module.exports = __webpack_public_path__ + "static/media/Hotel-LaMaiena.8823185e.jpg";